import { types } from "../types/types";

const initialState = {
    allSubAdmins: [],
    permissionCatalog: [],
};

const subAdminReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.SUB_ADMINS:
            return { ...state, allSubAdmins: action.payload || [] };
        case types.SUB_ADMIN_PERMISSION_CATALOG:
            return { ...state, permissionCatalog: action.payload || [] };
        default:
            return state;
    }
};

export default subAdminReducer;
